var React = require('react');

function MobileInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.91602 6.08341H19.0827V8.91675H21.916V3.25008C21.916 1.69175 20.641 0.430915 19.0827 0.430915L4.91602 0.416748C3.35768 0.416748 2.08268 1.69175 2.08268 3.25008V8.91675H4.91602V6.08341ZM16.8302 22.5026L23.3327 16.0001L16.8302 9.49758L14.8327 11.5092L19.3235 16.0001L14.8327 20.4909L16.8302 22.5026ZM9.16601 20.4909L4.67518 16.0001L9.16601 11.5092L7.16852 9.49758L0.666016 16.0001L7.16852 22.5026L9.16601 20.4909ZM19.0827 25.9167H4.91602V23.0834H2.08268V28.7501C2.08268 30.3084 3.35768 31.5834 4.91602 31.5834H19.0827C20.641 31.5834 21.916 30.3084 21.916 28.7501V23.0834H19.0827V25.9167Z","fill":"#276EF1"}));
}

MobileInline.defaultProps = {"width":"24","height":"32","viewBox":"0 0 24 32","fill":"none"};

module.exports = MobileInline;

MobileInline.default = MobileInline;
